import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.function.name";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Watch, Prop, PropSync } from 'vue-property-decorator';
import { validateor } from '@/utils/validate';
var defaultProxy = {
  litigationStatusId: '',
  litigationStatusName: '',
  procuratorName: '',
  phoneNo: '',
  dldx: [],
  idCardNo: '',
  certificateType: '',
  lawOffice: ''
};

var ProxyInfoFormDialog = /*#__PURE__*/function (_Vue) {
  _inherits(ProxyInfoFormDialog, _Vue);

  var _super = _createSuper(ProxyInfoFormDialog);

  function ProxyInfoFormDialog() {
    var _this;

    _classCallCheck(this, ProxyInfoFormDialog);

    _this = _super.apply(this, arguments);
    _this.dic = _this.$store.getters.dic;
    _this.proxyInfoFormRules = {
      litigationStatusId: validateor({
        required: true,
        trigger: 'change'
      }),
      procuratorName: validateor({
        required: true,
        type: 'name',
        maxLength: 32
      }),
      certificateType: validateor({
        required: true,
        trigger: 'change'
      }),
      idCardNo: validateor({
        required: true,
        type: 'card'
      }),
      phoneNo: validateor({
        required: true,
        type: 'mobile'
      }),
      lawOffice: validateor({
        type: 'name',
        maxLength: 32
      }),
      dldx: validateor({})
    };
    _this.proxyInfoForm = defaultProxy;
    _this.canClearDldx = false;
    _this.canSubmit = true;
    return _this;
  }

  _createClass(ProxyInfoFormDialog, [{
    key: "handleExistDataChange",
    value: function handleExistDataChange() {
      var _this2 = this;

      if (this.dialogFormVisible === true) {
        // 初始化
        this.canClearDldx = false;
        this.canSubmit = true; // 保证使用 defaultProxy 初始化 form，使 resetFields 方法符合预期
        // 否则先点击编辑后点击创建时，resetFields 会恢复为编辑时的数据
        // TODO 优化，会产生多余校验
        // 因为 form 有 resetFields 方法，所以直接修改 defaultProxy
        // 存在bug: 点击创建后编辑数据，点击取消，再点击编辑后点击确定或取消，再点击创建。执行了 resetFields() 但是第一次编辑的数据未被清空
        // 所以还是拷贝一份 defaultProxy

        this.proxyInfoForm = Object.assign({}, defaultProxy);

        if (this.existData) {
          this.$nextTick(function () {
            // 为避免修改原数据，拷贝一份 existData
            _this2.proxyInfoForm = Object.assign({}, _this2.existData);
          });
        } else {
          // 新建时 resetFields() 取消校验报错
          if (this.$refs.proxyInfoForm) {
            this.$refs.proxyInfoForm.resetFields();
          }
        }
      } else {
        if (this.$refs.proxyInfoForm) {
          this.$refs.proxyInfoForm.resetFields();
        }
      }
    } // TODO 修改 idCardNo 校验规则

  }, {
    key: "handleCertificateTypeChange",
    value: function handleCertificateTypeChange() {// this.proxyInfoFormRules.idCardNo = validateor({ required: true, type: 'identity' })
    } // 证件类型更新校验方式

  }, {
    key: "certificateTypeChange",
    value: function certificateTypeChange(val) {
      if (val === '111') {
        this.proxyInfoFormRules.idCardNo = validateor({
          required: true,
          type: 'identity'
        });
      } else {
        this.proxyInfoFormRules.idCardNo = validateor({
          required: true,
          type: 'card'
        });
      }
    }
  }, {
    key: "handleLitigationStatusIdChange",
    value: function handleLitigationStatusIdChange(id) {
      if (!id) return;
      var obj = this.litigationStatusIdOptions.find(function (item) {
        return item.id === id;
      });
      this.proxyInfoForm.litigationStatusName = obj.name; // 显示对话框后第一次修改不置空代理对象

      if (this.canClearDldx) {
        this.proxyInfoForm.dldx = [];
      }

      this.canClearDldx = true;
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this3 = this;

      this.canSubmit = false;
      var proxyInfoFormRef = this.$refs.proxyInfoForm;
      proxyInfoFormRef.validate(function (valid) {
        if (valid) {
          _this3.dialogFormVisible = false; // 拷贝一份 proxyInfoForm 传给 ProxyInfo（不拷贝应该也没事）

          _this3.$emit('submit', Object.assign({}, _this3.proxyInfoForm));
        } else {
          _this3.canSubmit = true;
        }

        proxyInfoFormRef.focusFirstField();
      });
    } // TODO 根据姓名搜索代理人

  }, {
    key: "queryProxies",
    value: function queryProxies() {}
  }, {
    key: "handleSelectProxy",
    value: function handleSelectProxy() {}
  }, {
    key: "dialogTitle",
    get: function get() {
      if (this.existData) {
        return '编辑代理人';
      }

      return '新建代理人';
    }
  }, {
    key: "dldxOptions",
    get: function get() {
      var _this4 = this;

      var res = this.clientList.filter(function (item) {
        return item.litigationStatusOneId === _this4.proxyInfoForm.litigationStatusId;
      });
      return res;
    }
  }]);

  return ProxyInfoFormDialog;
}(Vue);

__decorate([PropSync('visible', {
  required: true
})], ProxyInfoFormDialog.prototype, "dialogFormVisible", void 0);

__decorate([Prop({
  required: true
})], ProxyInfoFormDialog.prototype, "existData", void 0);

__decorate([Prop({
  required: true,
  type: Array
})], ProxyInfoFormDialog.prototype, "litigationStatusIdOptions", void 0);

__decorate([Prop({
  required: true
})], ProxyInfoFormDialog.prototype, "clientList", void 0);

__decorate([Watch('dialogFormVisible')], ProxyInfoFormDialog.prototype, "handleExistDataChange", null);

__decorate([Watch('proxyInfoForm.certificateType')], ProxyInfoFormDialog.prototype, "handleCertificateTypeChange", null);

ProxyInfoFormDialog = __decorate([Component], ProxyInfoFormDialog);
export default ProxyInfoFormDialog;